import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../hooks/useLanguage';
import { REG_FONTS } from './styles';

const LANG_OPTIONS = [
  { code: 'es', label: 'Espanol' },
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Francais' },
  { code: 'ar', label: 'العربية' },
] as const;

export function RegHeader() {
  const { t } = useTranslation('regularizacion');
  const { currentLang, setLanguage } = useLanguage();
  const [open, setOpen] = useState(false);

  const currentLabel = LANG_OPTIONS.find((l) => l.code === currentLang)?.label || 'Espanol';

  return (
    <header className="relative text-center pt-8 pb-6 max-sm:pt-4 max-sm:pb-4">
      {/* Language selector */}
      <div className="absolute right-0 top-8 max-sm:static max-sm:mb-4 max-sm:flex max-sm:justify-center">
        <div className="relative">
          <button
            onClick={() => setOpen(!open)}
            className="border border-[#ddd] bg-white rounded-full px-4 py-1.5 text-sm text-[#666] hover:border-[#2e7d32] hover:text-[#2e7d32] transition-colors cursor-pointer"
          >
            {currentLabel} ▾
          </button>
          {open && (
            <div className="absolute right-0 mt-1 bg-white border border-[#ddd] rounded-xl shadow-lg z-10 overflow-hidden min-w-[140px]">
              {LANG_OPTIONS.filter((l) => l.code !== currentLang).map((lang) => (
                <button
                  key={lang.code}
                  onClick={() => { setLanguage(lang.code); setOpen(false); }}
                  className="block w-full text-left px-4 py-2 text-sm text-[#444] hover:bg-[#e8f5e9] hover:text-[#2e7d32] transition-colors cursor-pointer"
                >
                  {lang.label}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      <p
        className="uppercase tracking-[3px] text-[11px] text-[#888] mb-2"
        style={{ fontFamily: REG_FONTS.body }}
      >
        {t('header.subtitle')}
      </p>

      <h1
        className="text-[28px] max-sm:text-[20px] font-black text-[#1a1a1a] leading-tight"
        style={{ fontFamily: REG_FONTS.heading }}
      >
        {t('header.title')}
      </h1>

      <p
        className="text-[#666] mt-2 text-base"
        style={{ fontFamily: REG_FONTS.body }}
      >
        {t('header.description')}
      </p>
    </header>
  );
}
